var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClioLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "249px",
    height: "48px",
    viewBox: "0 0 249 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CLIO Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0948060146 0.0919133893 248.89107 0.0919133893 248.89107 47.9049757 0.0948060146 47.9049757"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Account/User-Info/Dark-Theme",
    transform: "translate(-254.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom-Nav-Bar",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLIO-Logo",
    transform: "translate(254.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "90.8237705 0 101.535945 0 101.535945 43.3862023 129.602459 43.3862023 129.602459 45.9574468 90.8237705 45.9574468 90.8237705 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "145.637839 46.3244048 156.015938 46.3244048 156.015938 0.183770217 145.637839 0.183770217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.678679,24.0459567 C237.678679,11.5090835 226.935577,2.67499072 210.873858,2.67499072 C194.810559,2.67499072 184.069038,11.5090835 184.069038,24.0459567 C184.069038,36.6509306 194.810559,45.4185064 210.873858,45.4185064 C226.935577,45.4185064 237.678679,36.6509306 237.678679,24.0459567 Z M210.873858,48 C189.439798,48 172.802923,38.1127212 172.802923,24.0459567 C172.802923,10.319696 189.439798,0.0919133893 210.873858,0.0919133893 C232.307918,0.0919133893 248.89107,10.319696 248.89107,24.0459567 C248.89107,38.1127212 232.307918,48 210.873858,48 L210.873858,48 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6730961,33.1952134 C58.7560276,40.6862961 49.8553229,45.4185064 38.0709353,45.4185064 C22.0076362,45.4185064 11.2645346,36.6509306 11.2645346,24.0459567 C11.2645346,11.5090835 22.0076362,2.67499072 38.0709353,2.67499072 C49.8395219,2.67499072 58.732326,7.4293734 62.655715,14.8982837 L73.3972364,14.8982837 C67.873206,6.01826248 54.38073,0.0919133893 38.0709353,0.0919133893 C16.6368755,0.0919133893 0,10.319696 0,24.0459567 C0,38.1127212 16.6368755,48 38.0709353,48 C54.4660554,48 68.0138349,42.2098524 73.4825618,33.1952134 L62.6730961,33.1952134",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClioLogoWhite);
export default __webpack_public_path__ + "static/media/clio-logo-white.1d469b635fc7a423769363d076f1fca1.svg";
export { ForwardRef as ReactComponent };